import { render, staticRenderFns } from "./ItemMarket.vue?vue&type=template&id=ea3443f6&"
import script from "./ItemMarket.vue?vue&type=script&lang=ts&"
export * from "./ItemMarket.vue?vue&type=script&lang=ts&"
import style0 from "./ItemMarket.vue?vue&type=style&index=0&id=ea3443f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports